import FullScreenDialogAppBar from './FullScreenDialogAppBar';

export default FullScreenDialogAppBar;
